// extracted by mini-css-extract-plugin
module.exports = {"fab":"SelectedSegmentHud_fab__2-UAY","icon":"SelectedSegmentHud_icon__1e07-","link":"SelectedSegmentHud_link__1ZPgP"};